<template>
  <div>
    <p>
      This option allows the user to define some of the parameters (listed
      below) of the genetic algorithm used to optimise the constellation.
    </p>
    <ul>
      <li>
        <b>Survivors size</b> : the amount of individuals of the current
        population to be kept in the next population.
      </li>
      <li>
        <b>Offspring size</b> : the amount of children created by recombination
        and mutation of the survivors genes.
      </li>
      <li>
        <b>Maximum phenotype age</b> : the maximum number of consecutive
        generations an individual is allowed to survive.
      </li>
      <li>
        <b>Mutation probability</b> : the probability of mutation of each gene
        of each individual of the offspring population.
      </li>
      <li>
        <b>Maximum steady fitness number</b> : the maximum number of consecutive
        generations without any improvements with respect to the best individual
        cost value.
      </li>
      <li>
        <b>Maximum generations</b> : the maximum number of generations of the
        algorithm.
      </li>
      <li>
        <b>Maximum duration</b> : the maximum duration during which the genetic
        algorithm can run before stopping. When this time is reached, the
        current best individual is returned.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeneticOptimisationParameters'
}
</script>
